<ion-content>
	<ion-row class="ion-align-items-center ion-justify-content-end">
		<ion-icon
			(click)="goBack()"
			class="center pointer"
			size="large"
			src="/assets/icon/close.svg"
			role="img"
			aria-label="Close icon button"
		></ion-icon>
	</ion-row>
	<ion-col *ngIf="!loading && !authLogin">
		<div class="input-group">
			<p class="input-group__label">{{ 'sign_in.email' | translate }}*</p>
			<ion-input (ngModelChange)="validate()" [(ngModel)]="email" class="input-group__input" name="email" type="email"></ion-input>
		</div>
		<div class="input-group">
			<p class="input-group__label">{{ 'sign_in.password' | translate }}*</p>
			<ion-input
				(ngModelChange)="validate()"
				[(ngModel)]="password"
				[type]="showPassword ? 'text' : 'password'"
				class="input-group__input"
				name="password"
			>
			</ion-input>
			<ion-icon
				(click)="showPassword = false"
				*ngIf="showPassword"
				class="eye-icon"
				src="/assets/icon/eye.svg"
				role="img"
				tabindex="0"
				aria-label="Hide password"
			></ion-icon>
			<ion-icon
				(click)="showPassword = true"
				*ngIf="!showPassword"
				class="eye-icon"
				src="/assets/icon/eye_dis.svg"
				role="img"
				aria-label="Show password"
			></ion-icon>
		</div>

		<ion-row role="region" aria-label="Content row">
			<button (click)="signIn()" class="subway-btn filled">{{ 'sign_in.login' | translate }}</button>
		</ion-row>
	</ion-col>
	<ion-col *ngIf="!loading && authLogin">
		<p>
			Eingeloggt. Zum entfernen <a (click)="reset()" role="button" tabindex="0">hier</a> Klicken. Beachten Sie das ein erneutes Login
			manuell alle 24h gemacht werden muss.
		</p>
		<p>{{authLogin.token}}</p>
	</ion-col>
	<ion-row *ngIf="loading" class="ion-justify-content-center" role="region" aria-label="Loading content">
		<ion-spinner class="main-color"></ion-spinner>
	</ion-row>
</ion-content>
